import { render, staticRenderFns } from "./ANewEmpresa.vue?vue&type=template&id=7896e467"
import script from "./ANewEmpresa.vue?vue&type=script&lang=js"
export * from "./ANewEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports